import { Anchor, List, Stack, Text, Title } from "@mantine/core";
import { Section } from "$/components/section";
import { WHATSAPP_URL } from "$/data/links";

export default function PrivacyPage() {
  return (
    <Section>
      <Stack gap="xl" pt={64}>
        <Stack gap="xs">
          <Title order={1}>Política de Privacidade</Title>
          <Text c="gray.6" fz="sm">
            Última atualização: 18 de maio de 2026
          </Text>
        </Stack>

        <Stack gap="md">
          <Text c="gray.7">
            Esta Política descreve como o Verdana trata informações relacionadas ao uso do nosso
            site institucional e do software de gestão (mini-ERP) instalado no computador do
            usuário. Nosso compromisso é com a transparência e o respeito à Lei Geral de Proteção de
            Dados (LGPD - Lei nº 13.709/2018).
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            1. Quem somos
          </Title>
          <Text c="gray.7">
            O Verdana é desenvolvido por uma equipe pequena baseada em Garanhuns/PE, Brasil. Para
            qualquer assunto relacionado a esta Política, entre em contato pelos nossos canais
            oficiais.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            2. Dados tratados no site
          </Title>
          <Text c="gray.7">
            Quando você visita este site, podemos coletar dados de navegação como endereço IP
            (anonimizado), tipo de dispositivo, navegador, páginas acessadas e tempo de visita.
            Esses dados são utilizados para entender o uso da página e melhorar a experiência.
          </Text>
          <Text c="gray.7">
            Se você nos enviar uma mensagem (por WhatsApp, e-mail ou outro canal), trataremos os
            dados necessários para responder ao contato, como nome, telefone e o conteúdo da
            conversa.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            3. Dados tratados pelo software (mini-ERP)
          </Title>
          <Text c="gray.7">
            O Verdana é um software desktop. Os dados cadastrados (clientes, produtos, vendas,
            estoque etc.) são armazenados localmente, no computador do usuário. A equipe Verdana{" "}
            <strong>não</strong> acessa esse banco de dados local de forma rotineira. Eventuais
            acessos só ocorrem mediante solicitação expressa do usuário, por exemplo, em
            atendimentos de suporte técnico, e seguindo o princípio de mínima necessidade.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            4. Base legal para o tratamento
          </Title>
          <List spacing="xs" c="gray.7">
            <List.Item>
              <strong>Execução de contrato:</strong> para fornecer o software e o suporte
              contratado.
            </List.Item>
            <List.Item>
              <strong>Cumprimento de obrigação legal:</strong> para atender exigências fiscais,
              contábeis e regulatórias.
            </List.Item>
            <List.Item>
              <strong>Legítimo interesse:</strong> para melhorar o produto, prevenir fraudes e
              manter a segurança.
            </List.Item>
            <List.Item>
              <strong>Consentimento:</strong> quando aplicável, por exemplo, para envio de
              comunicações de marketing.
            </List.Item>
          </List>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            5. Compartilhamento de dados
          </Title>
          <Text c="gray.7">
            Não vendemos seus dados. Podemos compartilhar dados com prestadores de serviços
            essenciais à operação (como hospedagem do site e mensageria), sempre sob obrigação
            contratual de confidencialidade e segurança, ou com autoridades públicas quando exigido
            por lei.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            6. Cookies
          </Title>
          <Text c="gray.7">
            Este site pode utilizar cookies estritamente necessários ao seu funcionamento e, se for
            o caso, cookies de medição de audiência. Você pode gerenciar cookies a qualquer momento
            pelas configurações do seu navegador.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            7. Segurança
          </Title>
          <Text c="gray.7">
            Adotamos medidas técnicas e organizacionais razoáveis para proteger os dados sob nossa
            responsabilidade. Como o banco de dados do Verdana fica no computador do usuário,
            recomendamos manter o sistema operacional atualizado, utilizar senhas fortes e realizar
            backups periódicos.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            8. Retenção
          </Title>
          <Text c="gray.7">
            Mantemos dados pessoais apenas pelo tempo necessário ao cumprimento das finalidades
            descritas nesta Política ou conforme exigido por lei. Dados de navegação anônimos podem
            ser conservados em formato agregado para fins estatísticos.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            9. Seus direitos
          </Title>
          <Text c="gray.7">A LGPD garante a você, titular dos dados, o direito de:</Text>
          <List spacing="xs" c="gray.7">
            <List.Item>Confirmar a existência de tratamento dos seus dados.</List.Item>
            <List.Item>Acessar os dados.</List.Item>
            <List.Item>Corrigir dados incompletos, inexatos ou desatualizados.</List.Item>
            <List.Item>
              Solicitar a anonimização, o bloqueio ou a eliminação de dados desnecessários ou
              tratados em desconformidade com a lei.
            </List.Item>
            <List.Item>Solicitar a portabilidade dos dados.</List.Item>
            <List.Item>Revogar o consentimento, quando aplicável.</List.Item>
          </List>
          <Text c="gray.7">
            Para exercer esses direitos, entre em contato pelo nosso{" "}
            <Anchor href={WHATSAPP_URL} target="_blank" rel="noopener">
              WhatsApp
            </Anchor>
            .
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            10. Alterações desta Política
          </Title>
          <Text c="gray.7">
            Podemos atualizar esta Política periodicamente. A versão mais recente estará sempre
            disponível nesta página, com a data da última atualização no topo. Alterações relevantes
            serão comunicadas pelos canais habituais.
          </Text>
        </Stack>

        <Stack gap="md">
          <Title order={2} fz="h3">
            11. Contato
          </Title>
          <Text c="gray.7">
            Dúvidas sobre esta Política ou sobre o tratamento dos seus dados podem ser enviadas pelo
            nosso{" "}
            <Anchor href={WHATSAPP_URL} target="_blank" rel="noopener">
              WhatsApp
            </Anchor>
            .
          </Text>
        </Stack>
      </Stack>
    </Section>
  );
}
